import { Stack } from "@mantine/core";
import {
  ExpressionEditor,
  type ExpressionEditorProps
} from "../../FormFields/ExpressionEditor/ExpressionEditor";
import type { CommonFormFieldItemProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { HelperText } from "../HelperText/HelperText";
import type { FormFieldTextInputProps } from "./FormFieldTextInput";

interface FormFieldExpressionProps
  extends CommonFormFieldItemProps, ExpressionEditorProps {
  label?: FormFieldTextInputProps["label"];
  error?: string;
  disabled?: boolean;
  topArea?: React.ReactNode;
  type: "expression";
}

function FormFieldExpression({
  label,
  error,
  helpText,
  highlight,
  isBetaFeature,
  disabled,
  topArea,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldExpressionProps) {
  return (
    <Stack gap={0}>
      {label && (
        <FormFieldLabel
          helpText={helpText}
          highlight={highlight}
          isBetaFeature={isBetaFeature}
          label={label}
          required={fieldSpecificProps.required}
        />
      )}
      {topArea}
      <ExpressionEditor
        {...fieldSpecificProps}
        invalid={!!error}
        required={fieldSpecificProps.required}
      />
      <HelperText error={error} />
    </Stack>
  );
}

export { FormFieldExpression, FormFieldExpressionProps };
